module.exports = __webpack_public_path__ + "static/media/coach-2.f571822b.jpg";